import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

export const CarModificationsStyle = styled.div`
  .info-tip-container {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .not-listed {
    width: 296px;
    border-radius: 0px 4px 4px 0px;
    margin-top: ${theme.grid.spacing.s}px;
    border: 1px solid ${theme.tints.lightAubergine};
    cursor: pointer;
  }
  .mod-tool-tip {
    margin-left: ${theme.grid.spacing.xs}px;
  }
  @media (min-width: ${theme.grid.resolution.tablet.width}px) {
    .not-listed {
      width: 390px;
    }
  }
`
